import React, { useEffect } from 'react';

import routes from 'app/routes';

import {
  Outlet, useNavigate, useLocation, ScrollRestoration, useParams,
} from 'react-router-dom';

import { useContext } from 'components/Members/Programs/Views/Show/Context';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import { useContext as useUsersContext } from 'components/Users/Context';

export default function Index() {
  const navigate = useNavigate();
  const location = useLocation();

  const { dispatch, actions, state } = useContext();
  const { state: stateUsers } = useUsersContext();

  const member = stateUsers.user?.attributes?.specific;

  const { programId } = location.state || useParams() || {};

  useEffect(() => {
    if (state.program) {
      if (state.program.attributes.is_first_assessment_needed) {
        const nextUrl = routes.members.programs.new.talentAssessment(state.program.id);
        navigate(nextUrl, { replace: true });
      } else {
        const nextUrl = routes.members.programs.new.orderTopics(state.program.id);
        navigate(nextUrl, { replace: true });
      }
    }
    // let nextUrl = location.pathname.split('?')[0];
    // if (nextUrl === routes.members.programs.new.index) {
    //  nextUrl = routes.members.programs.new.orderTopics;
    // }
    // navigate(nextUrl, { replace: true });
  }, [state.program]);

  useEffect(() => {
    actions.prepareNewProgram(dispatch, 6, programId);
  }, []);

  if (state.program === null || member === null) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>

  );
}
